import type { FuncOverrideComponent } from '../theme.types';

export const MuiTypography: FuncOverrideComponent<'MuiTypography'> = () => ({
  styleOverrides: {
    gutterBottom: {
      marginBottom: 8,
    },
  },
});
